import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InfectionControlCategoriesComponent } from './infection-control-categories/infection-control-categories.component';
import { InfectionControlTrackingComponent } from './infection-control-tracking/infection-control-tracking.component';
import { InfectionControlPlaningComponent } from './infection-control-planing/infection-control-planing.component';

const routes: Routes = [
  { path: 'infection-control-categories', component: InfectionControlCategoriesComponent },
  { path: 'infection-control-tracking', component: InfectionControlTrackingComponent },
  { path: 'infection-control-planing', component: InfectionControlPlaningComponent },


  // Add other routes here if needed
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InfectionControlRoutingModule { }
